import React from 'react';
import MonkeyPatchGenerator from './MonkeyPatchGenerator';
import RouteScriptGenerator from './RouteScriptGenerator';
import { useDebugMode } from './useDebugMode';

const DebugControls = (props) => {
    const debugEnabled = useDebugMode();

    if (!debugEnabled) {
        return null;
    }

    const { routeProximity, onProximityChange, isDrivingMode, currentBearing, currentSpeed, activeLightDistance } = props;

    return (
        <div className="leaflet-control leaflet-bar" style={{ backgroundColor: 'white', padding: '0', margin: '0', width: '100%' }}>
            <div style={{ marginBottom: '5px', fontSize: '12px', fontWeight: 'bold' }}>Debug Info</div>
            <div style={{ fontSize: '11px', marginBottom: '5px' }}>
                <div>Mode: {isDrivingMode ? 'Driving' : 'Routing'}</div>
                <div>Bearing: {Math.round(currentBearing)}°</div>
                <div>Speed: {currentSpeed} km/h</div>
                <div>Next Light: {activeLightDistance ? `${Math.round(activeLightDistance)}m` : 'N/A'}</div>
                <div>Time to Light: {activeLightDistance && currentSpeed > 0 ? `${Math.round(activeLightDistance / (currentSpeed / 3.6))}s` : 'N/A'}</div>
            </div>
            <div style={{ marginBottom: '5px', fontSize: '12px' }}>
                Traffic Light Proximity: {routeProximity}m
            </div>
            <input
                type="range"
                min="10"
                max="100"
                value={routeProximity}
                onChange={onProximityChange}
                style={{ width: '100%' }}
            />
            <div style={{ marginBottom: '5px', fontSize: '12px' }}>
                HUD Distance: {props.hudDistanceThreshold}m
            </div>
            <input
                type="range"
                min="50"
                max="300"
                step="25"
                value={props.hudDistanceThreshold}
                onChange={props.onHudDistanceChange}
                style={{ width: '100%' }}
            />
            <div style={{ marginBottom: '5px', fontSize: '12px' }}>
                HUD Time: {props.hudTimeThreshold}s
            </div>
            <input
                type="range"
                min="5"
                max="30"
                step="5"
                value={props.hudTimeThreshold}
                onChange={props.onHudTimeChange}
                style={{ width: '100%' }}
            />

            {/* New console-based simulation generators */}
            <MonkeyPatchGenerator />
            <RouteScriptGenerator />
        </div>
    );
};

export default DebugControls;
